import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=b32ed612&scoped=true&"
import script from "./checklist.vue?vue&type=script&lang=js&"
export * from "./checklist.vue?vue&type=script&lang=js&"
import style0 from "./checklist.vue?vue&type=style&index=0&id=b32ed612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32ed612",
  null
  
)

export default component.exports